import playerRoleIcon from "../assets/player-role-icon.png";

/** Player mark: ping-pong paddles illustration — used on the Home/Profile role switcher. */
export default function PlayerRoleIcon({ sx, className = "", style, alt = "", ...props }) {
  const size = sx?.fontSize ?? 28;
  return (
    <img
      src={playerRoleIcon}
      alt={alt}
      className={`player-role-icon ${className}`.trim()}
      width={size}
      height={size}
      draggable={false}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        objectFit: "cover",
        display: "block",
        flexShrink: 0,
        ...style,
      }}
      {...props}
    />
  );
}
